import React from "react";
import { Button, Flex } from "ui-components";
import FormattedMessage from "components/FormattedMessage";
import get from "lodash/get";
import { getButtonColorVariant } from "ui-components/theme";
import { constructOnChangeHandler, safeEval } from "utils/helpers";
import TextField from "../FormFields/TextField";
import { setItem } from "../../utils/localStorage";

/**
 * Container to hold multiple NumberBox components
 * @param data
 * @param {object} props
 */
const OTPEmail = ({ data, ...props }) => {
  const {
    disabled,
    formValues,
    themeColors,
    fetchEmailOtp,
    otpParams,
    emailOtpParams,
    changeField,
    timerKey,
    resetValidateEmailOtp
  } = props;
  const { sendOTP } = data;
  const isDisabled = safeEval(get, formValues, disabled, false, props);
  const buttonVariant = "outline";
  const buttonTheme = get(themeColors, "button", {});
  const sendOTPEmail = get(emailOtpParams, "email");
  const currentEmail = get(formValues, "email");
  const buttonStyles = getButtonColorVariant(buttonTheme, buttonVariant);
  const OTP_TIMER_ID = timerKey || "general-otp-timer";
  const handleClick = e => {
    resetValidateEmailOtp();
    fetchEmailOtp(otpParams);
    changeField("enable_reset_link", false);
    setItem(`${OTP_TIMER_ID}.timer.startrecord`, Date.now());
  };

  return (
    <>
      <TextField
        {...props}
        {...data}
        onChange={props => {
          constructOnChangeHandler(props);
        }}
        disabled={isDisabled}
      />
      {sendOTPEmail !== currentEmail && (
        <Flex justifyContent="center" padding="0">
          <Button
            data-testid={"send-email-otp"}
            // disabled={loading}
            variant={"outline"}
            sx={buttonStyles}
            onClick={e => {
              e.preventDefault();
              handleClick();
            }}
          >
            <FormattedMessage id={sendOTP} />
          </Button>
        </Flex>
      )}
    </>
  );
};

export default OTPEmail;
